module.exports = __webpack_public_path__ + "img/brandImg2.99982988.jpg";